import IconAppStatusBarSuccessDefault from '~/assets/images/app-statusBar-success-default.svg'
import IconWebStatusBarSuccessDefault from '~/assets/images/web-statusBar-success-default.svg'
import IconAppStatusBarFailedDefault from '~/assets/images/app-statusBar-failed-default.svg'
import IconWebStatusBarFailedDefault from '~/assets/images/web-statusBar-failed-default.svg'
import IconAppStatusBarSuccessImtokenLight from '~/assets/images/app-statusBar-success-imtoken-light.svg'
import IconWebStatusBarSuccessImtokenLight from '~/assets/images/web-statusBar-success-imtoken-light.svg'
import IconAppStatusBarFailedImtokenLight from '~/assets/images/app-statusBar-failed-imtoken-light.svg'
import IconWebStatusBarFailedImtokenLight from '~/assets/images/web-statusBar-failed-imtoken-light.svg'
import IconAppStatusBarSuccessImtokenDark from '~/assets/images/app-statusBar-success-imtoken-dark.svg'
import IconWebStatusBarSuccessImtokenDark from '~/assets/images/web-statusBar-success-imtoken-dark.svg'
import IconAppStatusBarFailedImtokenDark from '~/assets/images/app-statusBar-failed-imtoken-dark.svg'
import IconWebStatusBarFailedImtokenDark from '~/assets/images/web-statusBar-failed-imtoken-dark.svg'
import webLeftLoadingDefault from '../../json/web-left-loading-default.json'
import webRightLoadingDefault from '../../json/web-right-loading-default.json'
import appLeftLoadingDefault from '../../json/app-left-loading-default.json'
import appRightLoadingDefault from '../../json/app-right-loading-default.json'
import webLeftLoadingImtokenLight from '../../json/web-left-loading-imtoken-light.json'
import webRightLoadingImtokenLight from '../../json/web-right-loading-imtoken-light.json'
import appLeftLoadingImtokenLight from '../../json/app-left-loading-imtoken-light.json'
import appRightLoadingImtokenLight from '../../json/app-right-loading-imtoken-light.json'
import webLeftLoadingImtokenDark from '../../json/web-left-loading-imtoken-dark.json'
import webRightLoadingImtokenDark from '../../json/web-right-loading-imtoken-dark.json'
import appLeftLoadingImtokenDark from '../../json/app-left-loading-imtoken-dark.json'
import appRightLoadingImtokenDark from '../../json/app-right-loading-imtoken-dark.json'
import { useBreakpoint, useIsInIframe } from '~/hooks'
import { useThemeName, isDarkThemeName } from '~/theme'

type Platform = 'app' | 'web'
type ThemeMode = 'light' | 'dark'

const loadingAssets = {
  default: {
    app: {
      left: appLeftLoadingDefault,
      right: appRightLoadingDefault,
    },
    web: {
      left: webLeftLoadingDefault,
      right: webRightLoadingDefault,
    },
  },
  imtoken: {
    light: {
      app: {
        left: appLeftLoadingImtokenLight,
        right: appRightLoadingImtokenLight,
      },
      web: {
        left: webLeftLoadingImtokenLight,
        right: webRightLoadingImtokenLight,
      },
    },
    dark: {
      app: {
        left: appLeftLoadingImtokenDark,
        right: appRightLoadingImtokenDark,
      },
      web: {
        left: webLeftLoadingImtokenDark,
        right: webRightLoadingImtokenDark,
      },
    },
  },
}

const statusBarAssets = {
  default: {
    app: {
      success: IconAppStatusBarSuccessDefault,
      failed: IconAppStatusBarFailedDefault,
    },
    web: {
      success: IconWebStatusBarSuccessDefault,
      failed: IconWebStatusBarFailedDefault,
    },
  },
  imtoken: {
    light: {
      app: {
        success: IconAppStatusBarSuccessImtokenLight,
        failed: IconAppStatusBarFailedImtokenLight,
      },
      web: {
        success: IconWebStatusBarSuccessImtokenLight,
        failed: IconWebStatusBarFailedImtokenLight,
      },
    },
    dark: {
      app: {
        success: IconAppStatusBarSuccessImtokenDark,
        failed: IconAppStatusBarFailedImtokenDark,
      },
      web: {
        success: IconWebStatusBarSuccessImtokenDark,
        failed: IconWebStatusBarFailedImtokenDark,
      },
    },
  },
}

export interface StatusBarAssets {
  leftLoading: object
  rightLoading: object
  success: string
  failed: string
}

export const useStatusBarAssets = (): StatusBarAssets => {
  const { isMobile } = useBreakpoint()
  const isInIframe = useIsInIframe()
  const themeName = useThemeName()
  const isDarkTheme = isDarkThemeName(themeName)
  const platform: Platform = isMobile ? 'app' : 'web'
  const themeMode: ThemeMode = isDarkTheme ? 'dark' : 'light'

  const currentLoadingAssets = isInIframe
    ? loadingAssets.imtoken[themeMode][platform]
    : loadingAssets.default[platform]

  const currentStatusBarAssets = isInIframe
    ? statusBarAssets.imtoken[themeMode][platform]
    : statusBarAssets.default[platform]

  return {
    leftLoading: currentLoadingAssets.left,
    rightLoading: currentLoadingAssets.right,
    success: currentStatusBarAssets.success,
    failed: currentStatusBarAssets.failed,
  }
}
